import dayjs from 'dayjs';

interface IUseGetLastSeenUserProps {
    lastSeenMinutes: number | null;
    timestamp: string | undefined;
}

export default function useGetLastSeenText({ lastSeenMinutes, timestamp }: Readonly<IUseGetLastSeenUserProps>) {
    const lastSeenText =
        timestamp && lastSeenMinutes ? (lastSeenMinutes < 3 ? 'Present' : dayjs(timestamp).fromNow()) : 'Long time ago';
    return lastSeenText;
}
